/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import ModelRefFieldItemEdit from "./edit-item";

const ModelRefFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <ModelRefFieldItemEdit />
        </FieldListEditWrapper>
    );
};
ModelRefFieldEdit.displayName = "ModelRefFieldEdit";
export { ModelRefFieldEdit };
